<script setup lang="ts">
import InAppSpy from 'inapp-spy'
defineProps({
  isInit: { type: Boolean }
})

const { t } = useI18n()
const hasInit = ref(false)
const init = () => {
  const { appName } = InAppSpy()
  const userAgentStr = window.navigator.userAgent
  const isAlipay = /AlipayClient/.test(userAgentStr)
  const isWeibo = /Weibo/.test(userAgentStr)
  const isAweme = /aweme/.test(userAgentStr)
  const isIqiyi = /iqiyi/.test(userAgentStr)
  const iskdtUnion_iting = /kdtUnion_iting/.test(userAgentStr)
  const isDingTalk = /DingTalk/.test(userAgentStr)
  // appName "Snapchat" | "Facebook Messenger" | "Facebook" | "Twitter" | "Line" | "WeChat" | "Instagram" | "TikTok"
  const appNameArr = [
    'Snapchat',
    'Line',
    'WeChat',
    'TikTok',
    'Instagram',
    'Facebook',
    'Facebook Messenger',
    'Twitter',
  ]
  if (
    isAlipay ||
    isWeibo ||
    isAweme ||
    isIqiyi ||
    iskdtUnion_iting ||
    isDingTalk ||
    appNameArr.includes(appName as string)
  ) {
    hasInit.value = true
  } else {
    hasInit.value = false
  }
}

const check = () => {
  return hasInit.value
}

onMounted(() => {
  init()
})

defineExpose({ check })
</script>

<template>
  <div
    v-if="hasInit && !isInit"
    class="sticky top-0 h-11 w-full px-4 sm:hidden flex items-center justify-between brand-gradient"
  >
    <img src="@/assets/newLogo/Logo_full_white.webp" class="h-4.5" alt="dfans" />
    <div class="text-3.25 text-white flex items-center">
      {{ t('Global.Tap') }}
      <div i-material-symbols:more-horiz class="w-4 h-4 mx-1" />
      {{ t('Global.OpenExternalBrowser') }}
      <div i-material-symbols:arrow-upward-rounded class="w-4 h-4 ml-1" />
    </div>
  </div>
  <!-- <div class="pt-4 z-9999 bg-black fixed top-0 left-0 w-full h-full hidden">
    <div class="flex items-end justify-between px-4">
      <div class="flex items-center">
        <span class="rounded-full df-b border w-8 h-8 flex items-center justify-center">1</span>
        <p class="mx-3">
          Click the top right button
        </p>
        <img src="@/assets/image/browser-more.webp" class="w-h h-7">
      </div>
      <img src="@/assets/image/guide-arrow.webp" class="max-w-1/4 mb-4 ml-3">
    </div>
    <div class="flex items-center mt-9.5 px-4">
      <span class="rounded-full df-b border w-8 h-8 flex items-center justify-center">2</span>
      <p class="mx-3">
        Choose "Open in external browser"
      </p>
      <img src="@/assets/image/browser.webp" class="w-h h-7">
    </div>
  </div> -->
</template>
